var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCreditCart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41099 0.399048C4.20331 0.399048 3.04509 0.932749 2.19113 1.88274C1.33717 2.83274 0.857422 4.12121 0.857422 5.4647L0.857422 25.7273C0.857422 27.0708 1.33717 28.3593 2.19113 29.3093C3.04509 30.2593 4.20331 30.793 5.41099 30.793H32.7324C33.9401 30.793 35.0983 30.2593 35.9523 29.3093C36.8062 28.3593 37.286 27.0708 37.286 25.7273V5.4647C37.286 4.12121 36.8062 2.83274 35.9523 1.88274C35.0983 0.932749 33.9401 0.399048 32.7324 0.399048H5.41099ZM35.0092 5.4647V18.1288H3.13421V5.4647C3.13421 4.79296 3.37408 4.14872 3.80106 3.67372C4.22804 3.19873 4.80715 2.93188 5.41099 2.93188H32.7324C33.3363 2.93188 33.9154 3.19873 34.3424 3.67372C34.7693 4.14872 35.0092 4.79296 35.0092 5.4647ZM32.7324 28.2602H5.41099C4.80715 28.2602 4.22804 27.9933 3.80106 27.5183C3.37408 27.0433 3.13421 26.3991 3.13421 25.7273V23.1945H35.0092V25.7273C35.0092 26.3991 34.7693 27.0433 34.3424 27.5183C33.9154 27.9933 33.3363 28.2602 32.7324 28.2602Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreditCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/credit-cart.a9bf0dc3.svg";
export { ForwardRef as ReactComponent };